import { css } from '@repo/pandacss/styled-system/css';

export function AdvertisingDisclosureTooltipContent() {
  return (
    <>
      <p className={css({ textStyle: 'text' })}>
        We believe everyone should be able to make financial decisions with confidence. While we
        don&apos;t cover every company or financial product on the market, we work hard to share a
        wide range of offers and objective editorial perspectives.
      </p>
      <p className={css({ textStyle: 'text' })}>
        So how do we make money? Our partners compensate us for advertisements that appear on our
        site. This compensation helps us provide tools and services - like free credit score access
        and monitoring. With the exception of mortgage, home equity and other home-lending products
        or services, partner compensation is one of several factors that may affect which products
        we highlight and where they appear on our site. Other factors include your credit profile,
        product availability and proprietary website methodologies.
      </p>
      <p className={css({ textStyle: 'text' })}>
        However, these factors{' '}
        <span className={css({ textStyle: 'textBold' })}>
          do not influence our editors&apos; opinions or ratings
        </span>
        , which are based on independent research and analysis. Our partners cannot pay us to
        guarantee favorable reviews.{' '}
        <a href="https://www.nerdwallet.com/p/our-partners">Here is a list of our partners.</a>
      </p>
    </>
  );
}
